import {
	GridCustomCellProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import { FC, useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";

// const handleFocus = (event: any) => {
// 	// Select full content when focusing
// 	event.target.select();
// };

export const NumericalCellAutoFocus: FC<
	GridCustomCellProps & {
		unit?: string;
		showError?: boolean;
		decimalScale?: number;
		fixedDecimalScale?: boolean;
		inputRef?: React.Ref<HTMLInputElement>;
		autoFocus?: boolean;
		onFocus?: (e: any) => void;
		onBlur?: (e: any) => void;
		onChange?: (e: any) => void;
		onValueChange?: (e: any) => void;
	}
> = ({
	field,
	dataItem,
	unit,
	tdProps,
	showError = false,
	decimalScale,
	fixedDecimalScale = false,
	autoFocus = false,
	...props
}) => {
	const [value, setValue] = useState(
		dataItem[field as any] ? dataItem[field as any] : 0
	);
	const inputElRef = useRef<HTMLInputElement | null>(null);
	const isFocused = (dataItem: any, field?: string) => {
		if (
			!field ||
			field === undefined ||
			!dataItem.onfocus ||
			!dataItem.focusedField
		) {
			return false;
		}
		const test = dataItem.onfocus && dataItem.focusedField === field;
		return test;
	};

	const onBlur = (e: any) => {
		//console.log('onblur', e);
		// try {
		// 	const el = inputElRef.current as HTMLInputElement | null;
		// 	if (el) {
		// 		const start = el.selectionStart ?? 0;
		// 		const end = el.selectionEnd ?? 0;
		// 		const len = (el.value ?? "").length;
		// 		if (len > 0 && start === 0 && end === len) {
		// 			el.setSelectionRange(len, len);
		// 		}
		// 	}
		// } catch {}

		if (!props.onChange) {
			return;
		}
		props.onChange({
			dataItem,
			dataIndex: props.dataIndex,
			syntheticEvent: e,
			field,
			value,
		});

		if (props.onBlur) {
			props.onBlur({
				dataItem: dataItem,
				columnIndex: props.columnIndex,
				syntheticEvent: e,
				field: field,
				value: e.target.value,
				dataIndex: props.dataIndex,
				rowIndex: props.rowDataIndex,
			});
		}
	};

	const onValueChange = (e: any) => {
		setValue(e.floatValue);
		if (props.onValueChange) {
			props.onValueChange({
				dataItem: dataItem,
				columnIndex: props.columnIndex,
				syntheticEvent: e,
				field: field,
				value: e.floatValue,
				dataIndex: props.dataIndex,
				rowIndex: props.rowDataIndex,
			});
		}
	};

	//Rely on onFocus to handle selection, to avoid stealing focus on Tab
	useEffect(() => {
		if (isFocused(dataItem, field)) {
			const el = inputElRef.current;
			if (el && document.activeElement === el) {
				// console.log("selecting el", isFocused(dataItem, field), field);
				el.select();
			}
		}
	}, []);

	return (
		<td {...tdProps} style={{ ...props.style }} className={props.className}>
			<NumericFormat
				getInputRef={(el: HTMLInputElement | null) => {
					inputElRef.current = el as any;
					if (props.inputRef) {
						if (typeof props.inputRef === "function") {
							(props.inputRef as any)(el);
						} else {
							(props.inputRef as any).current = el;
						}
					}
				}}
				className="grid-td-input k-input"
				width="90%"
				readOnly={!dataItem.inEdit}
				//value={dataItem[field as any] ? dataItem[field as any] : 0}
				value={dataItem[field as any] ? dataItem[field as any] : ""}
				// value={value}
				allowNegative={false}
				decimalScale={decimalScale}
				allowedDecimalSeparators={[".", ","]}
				fixedDecimalScale={fixedDecimalScale}
				decimalSeparator=","
				thousandSeparator=" "
				style={{ border: showError ? "1px solid red" : "" }}
				onFocus={(e) => {
					if (props.onFocus) {
						props.onFocus({
							dataItem: dataItem,
							columnIndex: props.columnIndex,
							syntheticEvent: e,
							field: field,
							value: e.target.value,
							dataIndex: props.dataIndex,
							rowIndex: props.rowDataIndex,
						});
					}
					// Re-select after any parent state updates caused by onFocus
					// setTimeout(() => {
					// 	try {
					// 		const el = inputElRef.current;
					// 		if (el && document.activeElement === el) {
					// 			el.select();
					// 		}
					// 	} catch {}
					// }, 0);
				}}
				autoFocus={isFocused(dataItem, field)}
				onValueChange={onValueChange}
				onChange={(e) => {
					// if (props.onChange) {
					// 	props.onChange({
					// 		dataItem,
					// 		columnIndex: props.columnIndex,
					// 		syntheticEvent: e,
					// 		field,
					// 		value: e.target.value,
					// 		dataIndex: props.dataIndex,
					// 		rowIndex: props.rowDataIndex,
					// 	});
					// }
				}}
				onBlur={onBlur}
			/>
			{unit && <span>{unit}</span>}
		</td>
	);
};

export const NumericalHeader: FC<GridHeaderCellProps> = (props) => {
	return <span>{props.title}</span>;
};
